"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconsExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var iconNames = Object.keys(_1.Icons).slice(1);
var IconsExample = /** @class */ (function () {
    function IconsExample() {
        this.searchQuery = '';
    }
    IconsExample.prototype.view = function () {
        var _this = this;
        var icons = this.getFilteredIcons();
        var searchInput = (0, mithril_1.default)(_1.Input, {
            autofocus: true,
            contentLeft: (0, mithril_1.default)(_1.Icon, { name: _1.Icons.SEARCH }),
            contentRight: this.searchQuery ? (0, mithril_1.default)(_1.Icon, {
                name: _1.Icons.X,
                onclick: function () { return _this.searchQuery = ''; }
            }) : undefined,
            fluid: true,
            placeholder: 'Search icons...',
            oninput: function (e) { return _this.searchQuery = e.target.value; },
            style: 'margin-bottom: 30px',
            value: this.searchQuery
        });
        var cols = icons.map(function (iconName) { return (0, mithril_1.default)(_1.Col, { span: 4 }, [
            (0, mithril_1.default)(_1.Card, { class: 'cui-example-icon-card', interactive: true }, [
                (0, mithril_1.default)(_1.Icon, {
                    name: _1.Icons[iconName],
                    size: 'xl'
                }),
                (0, mithril_1.default)('span', _1.Icons[iconName])
            ])
        ]); });
        return [
            searchInput,
            (0, mithril_1.default)(_1.Grid, { gutter: 10 }, cols)
        ];
    };
    IconsExample.prototype.getFilteredIcons = function () {
        if (!this.searchQuery) {
            return iconNames;
        }
        var query = this.searchQuery.toLowerCase();
        return iconNames.filter(function (iconName) { return _1.Icons[iconName].toLowerCase().includes(query); });
    };
    return IconsExample;
}());
exports.IconsExample = IconsExample;
